export default {
    namespaced: true,

    state: {
        notes: null,
        notifications: null,
        statements: null,
        documents: null,
    },

    getters: {
        hasNotes: (state) => {
            return (state.notes && state.notes.RowCount);
        },
        hasNotifications: (state) => {
            return (state.notifications && state.notifications.RowCount);
        },
        hasStatements: (state) => {
            return (state.statements && state.statements.RowCount);
        },
    },

    actions: {
        getNotifications({ commit }, params) {
            commit('setNotifications', null);

            return axios.get('/api/contacts/notifications', {
                params: params,
            })
            .then((response) => {
                commit('setNotifications', response.data.data);
            })
            .catch(() => {
                commit('setNotifications', []);
            });
        },
        getNotes({ commit }, params) {
            commit('setNotes', null);

            return axios.get('/api/contacts/notes', {
                params: params,
            })
            .then((response) => {
                commit('setNotes', response.data.data);
            })
            .catch(() => {
                commit('setNotes', []);
            });
        },
        getStatements({ commit }, params) {
            commit('setStatements', null);

            return axios.get('/api/contacts/statements', {
                params: params,
            })
            .then((response) => {
                commit('setStatements', response.data.data);
            })
            .catch(() => {
                commit('setStatements', []);
            });
        },
        getDocuments({ commit }, notePK) {
            commit('setDocuments', null);

            return axios.get(`/api/contacts/notes/${notePK}/documents`)
            .then((response) => {
                commit('setDocuments', response.data.data);
            })
            .catch(() => {
                commit('setDocuments', []);
            });
        },
    },

    mutations: {
        setNotes(state, notes) {
            state.notes = notes;
        },
        setNotifications(state, notes) {
            state.notifications = notes;
        },
        setStatements(state, statements) {
            state.statements = statements;
        },
        setDocuments(state, documents) {
            state.documents = documents;
        },
    },
};
